import ServiceBase from './ServiceBase';

export default class GiftCardService extends ServiceBase {
    constructor($http) {
        super($http);
    }

    getApplicableGiftCards(projectID) {
        return this.request('get', 'giftCard/getApplicableGiftCards', { params: { projectID } });
    }

    getUserGiftCards() {
        return this.request('get', 'giftCard/getUserGiftCards');
    }

    getGiftCardHistory(giftCardID) {
        return this.request('get', 'giftCard/getGiftCardHistory', { giftCardID });
    }
}
